import { ViewSnapshotModal } from "./ViewSnapshotModal";

export default ViewSnapshotModal;
